// src/layouts/AuthLayout.js
import React from "react";
import { Outlet } from "react-router-dom";

function AuthLayout({ children }) {
  return (
      <><Outlet /></>
  );
}

export default AuthLayout;
